import { useEffect } from "react";
import Pieces from "./Pieces";
import Intro from "./Intro";
import Galerie from "./Galerie";
import Marquee from "./Marquee";
import Maison from "./Maison";
import Registre from "./Registre";
import Club from "./Club";
import Engagements from "./Engagements";
import Fondateur from "./Fondateur";
import Carte from "./Carte";
import Contact from "./Contact";
import Footer from "./Footer";
import { scrollToId } from "./hooks";

export default function Home({ lang }) {
  // When arriving with a hash (e.g. navigating "/#club" from another route),
  // scroll to the target section once the sections have mounted.
  useEffect(() => {
    const hash = window.location.hash ? window.location.hash.slice(1) : "";
    if (hash) {
      const id = setTimeout(() => scrollToId(hash), 320);
      return () => clearTimeout(id);
    }
  }, []);

  return (
    <main className="site" data-testid="home-main">
      <Pieces lang={lang} />
      <Intro lang={lang} />
      <Galerie lang={lang} />
      <Marquee lang={lang} />
      <Maison lang={lang} />
      <Registre lang={lang} />
      <Club lang={lang} />
      <Engagements lang={lang} />
      <Fondateur lang={lang} />
      <Carte lang={lang} />
      <Contact lang={lang} />
      <Footer lang={lang} />
    </main>
  );
}
